<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<app-footer></app-footer>

<div class="content-page">
    <div class="content">
        <div class="container-fluid">
            <div class="card-deck quick-links">
                @if (security.permitted('inventory', 'inventory list', 'add')) {
                    <div class="card bg-success" (click)="addVehicle()">
                        <div class="card-body">
                            <span class="material-icons md-36">directions_car</span>
                            <h4>Add Vehicle to Inventory</h4>
                        </div>
                    </div>
                }

                @if (security.permitted('sales', 'sale list', 'add')) {
                    <div class="card bg-info" (click)="addSale()">
                        <div class="card-body">
                            <span class="material-icons md-36">sell</span>
                            <h4>Create a New Sale</h4>
                        </div>
                    </div>
                }

                @if (security.permitted('users', 'user list', 'add')) {
                    <div class="card bg-primary" [routerLink]="['/settings/users/']">
                        <div class="card-body">
                            <span class="material-icons-outlined md-36">account_circle</span>
                            <h4>Invite a New User</h4>
                        </div>
                    </div>
                }

                @if (security.permitted('corporation setup', 'corporate list', 'view')) {
                    <div class="card bg-secondary" [routerLink]="['/settings/corporations/']">
                        <div class="card-body">
                            <span class="material-icons md-36">settings</span>
                            <h4>Setup Dealership</h4>
                        </div>
                    </div>
                }
            </div>

            <div class="card-deck user-activity">

                <sales-in-progress [words]="words" [language]="language" />

                <recents [words]="words" [language]="language" />

                <favorites [words]="words" [language]="language" />

            </div>

            <div class="card-deck system-automation">

                <receivables-automation [words]="words" [language]="language" />

                <stats-automation [words]="words" [language]="language" />

            </div>

            @if (security.permitted('reports', 'past due analysis', 'view')) {
                <div class="card-deck stats">

                    <recency-chart [words]="words" [language]="language" [latest]="latest" />

                    <delinquency-chart [words]="words" [language]="language" [latest]="latest" />

                </div>
            }

            <div class="card-deck stats">

                <inventory-aging-chart [words]="words" [language]="language" [latest]="latest" />

            </div>

        </div>
    </div>
</div>
